import { combineReducers } from "@reduxjs/toolkit";

import authenticationSlice from "features/authentication/authenticationSlice";

const rootReducer = combineReducers({
  authentication: authenticationSlice
});

export default rootReducer;
